var _g, _rect, _g2, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHowitworks2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 69,
    viewBox: "0 0 69 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1037_1269)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 34.5,
    cy: 34.5,
    r: 32.5,
    fill: "#545454"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34.5,
    cy: 34.5,
    r: 32,
    stroke: "#F58634"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1037_1269",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 17,
    width: 36,
    height: 36
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 17,
    width: 36,
    height: 36,
    fill: "#D9D9D9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1037_1269)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.425 38L41.85 30.575L39.7125 28.475L34.425 33.7625L32.2875 31.625L30.15 33.7625L34.425 38ZM25.5 48.5V24.5C25.5 23.675 25.7938 22.9688 26.3813 22.3813C26.9688 21.7938 27.675 21.5 28.5 21.5H43.5C44.325 21.5 45.0312 21.7938 45.6188 22.3813C46.2063 22.9688 46.5 23.675 46.5 24.5V48.5L36 44L25.5 48.5ZM28.5 43.925L36 40.7L43.5 43.925V24.5H28.5V43.925Z",
    fill: "#F58634"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1037_1269",
    x: 0,
    y: 0,
    width: 69,
    height: 69,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1037_1269"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1037_1269",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHowitworks2);
export default __webpack_public_path__ + "static/media/howitworks2.9f387458ff739269d6e19e7e62eed9bc.svg";
export { ForwardRef as ReactComponent };